import React from "react";
import PropTypes from "prop-types";

const DataRow = ({ title, primaryValue, secondaryValue, isFirstRow }) => {
  return (
    <div className="flex row">
      <div className={`b-1-3 data-text ${isFirstRow ? "first-column" : "value-row first"}`}>
        {title}
      </div>
      <div className={`b-1-3 data-text second ${isFirstRow ? "first-row" : "value-row"}`}>
         {primaryValue}
      </div>
      <div className={`b-1-3 data-text third ${isFirstRow ? "first-row" : "value-row"}`}>
        {secondaryValue}
      </div>
    </div>
  );
};

DataRow.propTypes = {
  title: PropTypes.node,
  primaryValue: PropTypes.node,
  secondaryValue: PropTypes.node,
  isFirstRow: PropTypes.bool,
};

export default DataRow;
